<div class="error-page">
  <img [src]="companyLogoPath" alt="company logo" class="error-page__header" />
  <div class="error-page__main">
    <ng-container *ngIf="!forbidden; else forbiddenTemplate">
      <span>Oops! It looks like something is wrong with the URL: </span><a [href]="attemptedUrl">{{ attemptedUrl }}</a>
      <p>
        Please try to use the original link or
        <ng-container *ngTemplateOutlet="kaplanEmail"></ng-container>
      </p>
    </ng-container>
  </div>
</div>

<ng-template #forbiddenTemplate>
  <p>Sorry, you cannot access this private page.</p>
  <ng-container *ngTemplateOutlet="kaplanEmail"></ng-container>
</ng-template>

<ng-template #kaplanEmail>
  contact your Kaplan/Alpadia partner <a href="mailto:klgpartners@kaplaninternational.com">klgpartners&#64;kaplaninternational.com</a>
</ng-template>
